import { StoreContentSort } from 'common/types/entities/store'
import { Sort } from 'common/constants'
import { StateKey } from 'common/utils/flipState'
const initialState: StoreContentSort = {
  sort: Sort.RECENT,
}

const SET = '/store/fashionBrand/contentSort/SET'

export const setSort = (curState: StateKey, sort: Sort) => {
  return {
    curState,
    sort,
    type: SET,
  }
}

const sortReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        sort: action.sort,
      }
    default:
      return state
  }
}

export default sortReducer
